import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=6b6d9c49&scoped=true&"
import script from "./Expired.vue?vue&type=script&lang=js&"
export * from "./Expired.vue?vue&type=script&lang=js&"
import style0 from "./Expired.vue?vue&type=style&index=0&id=6b6d9c49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d9c49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
